import { render, staticRenderFns } from "./PollStart.vue?vue&type=template&id=87d38b24"
import script from "./PollStart.vue?vue&type=script&lang=js"
export * from "./PollStart.vue?vue&type=script&lang=js"
import style0 from "./PollStart.vue?vue&type=style&index=0&id=87d38b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports